export default __webpack_public_path__ + "static/media/circle-1.eee6fa08.png";